import { featureFlagsTracking } from "@/contexts/CdpProvider";
import { useTracking } from "@/contexts/classified";
// Import of useThorEvent is only allowed here as this is a wrapper hook
// eslint-disable-next-line no-restricted-imports
import { 
// eslint-disable-next-line no-restricted-imports
useThorView, } from "@aviv-dxp/react-thor";
export const useTrackingViewBase = (viewProps) => {
    var _a, _b;
    const { av_client_type, av_items } = (_a = useTracking()) !== null && _a !== void 0 ? _a : {};
    const av_client_id = (_b = av_items === null || av_items === void 0 ? void 0 : av_items[0]) === null || _b === void 0 ? void 0 : _b.client_id;
    const extendedViewProps = Object.assign(Object.assign({}, viewProps), { av_ab_test_variant: featureFlagsTracking, av_client_type,
        av_client_id });
    return useThorView({ viewProps: extendedViewProps });
};
